<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
body {
  background-color: #fff;
  color: #222;
  cursor: default;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12pt;
}
</style>

<script>
export default {
  name: 'App',
  watch: {
    $route: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      handler(to) {
        document.title = to.meta.title || 'Teary';
      },
    },
  },
};
</script>
